import {
    normalizeReportOrdersList,
    normalizeReportOrdersListTotals,
} from '@utils/storeDataNormalization';
import { storeConstants } from '@utils/constants';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import { apiService } from '@api';

const STORE_NAME = 'orders';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.reports.orders.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },
        mapListItemFn: normalizeReportOrdersList,
    },
    {
        state: {
            filters: {},
        },
        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
            reportTotals: (state) => normalizeReportOrdersListTotals(state.totals),
        },
        mutations: {
            [mutationTypes.UPDATE_FILTERS](state, { filters }) {
                state.filters = filters;
            },
            [mutationTypes.CLEAR_DATA](state) {
                state.list = [];
                state.totalCount = 0;
                state.loading = 0;
                state.allItemsLoaded = false;
                state.refresh = false;
                state.detail = {};
                state.totals = null;
                state.filters = {};
            },
        },
        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit(mutationTypes.UPDATE_FILTERS, { filters });
            },
        },
    }
);

export default store;
